import { render, staticRenderFns } from "./extra-details-pbehavior.vue?vue&type=template&id=1a56e6a9&"
import script from "./extra-details-pbehavior.vue?vue&type=script&lang=js&"
export * from "./extra-details-pbehavior.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports